import * as React from 'react'
import {useSpring, config, animated} from '@react-spring/web'
import styled from 'styled-components/macro'
import {Minus, Plus} from 'phosphor-react'

import {useHeight} from 'common/useHeight'

const QuestionBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 24px;
  background: var(--white);
  border: 1px solid var(--darker-grey);
  border-radius: 5px;
`

const Question = styled.div`
  font-family: 'Rubik';
  font-style: italic;
  font-weight: 400;
  font-size: calc(18 / 16 * 1rem);
  line-height: calc(22 / 16 * 1rem);
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: ${p =>
    p.showingAnswer ? 'var(--light-green)' : 'var(--darker-grey)'};
  display: flex;
  justify-content: space-between;
  width: 100%;
`

const AnswerContainer = styled(animated.div)`
  overflow: hidden;
`

const Answer = styled.div`
  padding-top: 16px;
  font-family: 'Mulish';
  font-weight: 300;
  font-size: calc(16 / 16 * 1rem);
  line-height: calc(20 / 16 * 1rem);
  color: var(--darker-grey);
`

const StyledMinus = styled(Minus)`
  cursor: pointer;
`

const StyledPlus = styled(Plus)`
  cursor: pointer;
  min-width: 24px;
`

const FAQItem = ({faq, index, answersOpen, hideAnswer, showAnswer}) => {
  const [heightRef, height] = useHeight()
  const showingAnswer = answersOpen.findIndex(ans => ans === index) > -1

  const slideInStyles = useSpring({
    config: {...config.stiff},
    from: {opacity: 0, height: 0},
    to: {
      opacity: showingAnswer ? 1 : 0,
      height: showingAnswer ? height : 0,
    },
  })
  return (
    <QuestionBox>
      <Question showingAnswer={showingAnswer}>
        {faq.question}
        {showingAnswer ? (
          <StyledMinus
            color="var(--light-green)"
            size={32}
            onClick={() => hideAnswer(index)}
          />
        ) : (
          <StyledPlus
            color="var(--darker-grey)"
            size={32}
            onClick={() => showAnswer(index)}
          />
        )}
      </Question>
      <AnswerContainer style={{...slideInStyles}}>
        <Answer
          ref={heightRef}
          dangerouslySetInnerHTML={{
            __html: faq.answer.replaceAll('\n', '<br />'),
          }}
        ></Answer>
      </AnswerContainer>
    </QuestionBox>
  )
}
export default FAQItem
